import { useSyncExternalStore } from "react";

import { getSaveFailure, subscribeSaveFailure, type SaveFailure } from "./settingsStore";

/** 設定の保存ができているかを購読する。参照は成否が変わったときだけ変わる。 */
export function useSaveFailure(): SaveFailure {
    return useSyncExternalStore(subscribeSaveFailure, getSaveFailure, getSaveFailure);
}
